import { ParseKeys } from 'i18next';
import { ReactNode, useState } from 'react';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/common/components/ui/select';

const EMPTY_STRING_SENTINEL = '__EMPTY_STRING_VALUE__';

export interface SelectFilterOption {
  value: string;
  label: string | ParseKeys | ReactNode;
}

interface SelectFilterProps {
  label?: string | ParseKeys;
  value: string;
  onChange: (value: string) => void;
  options: SelectFilterOption[];
  placeholder?: string;
  minWidth?: string;
  onClose?: () => void;
  textSize?: string;
}

export const SelectFilter = ({
  label,
  value,
  onChange,
  options,
  placeholder,
  minWidth = 'min-w-[160px]',
  onClose,
  textSize = 'text-xxs',
}: SelectFilterProps) => {
  const [open, setOpen] = useState(false);
  const internalValue = value === '' ? EMPTY_STRING_SENTINEL : value;

  const handleValueChange = (newValue: string) => {
    const externalValue = newValue === EMPTY_STRING_SENTINEL ? '' : newValue;
    onChange(externalValue);
    setOpen(false);
    onClose?.(); // Ferme le popup parent
  };

  return (
    <Select
      value={internalValue}
      onValueChange={handleValueChange}
      open={open}
      onOpenChange={setOpen}
    >
      <SelectTrigger className={`h-7 ${textSize} ${minWidth} cursor-pointer`}>
        {label && <span className="text-muted-foreground">{label}:</span>}
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {options.map((option, index) => {
          const optionValue =
            option.value === '' ? EMPTY_STRING_SENTINEL : option.value;
          return (
            <SelectItem key={`${option.value}-${index}`} value={optionValue}>
              {option.label}
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
};
